import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as PartnerStoreActions from './partnerStore.actions';
import { catchError, concatMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { globalFailure } from './../../../app/@store/common.actions';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@gridscale/ingrid/helper/services/config.service';

@Injectable()
export class PartnerStoreEffects {
  readonly #configService = inject(ConfigService);
  /*
    ngrxOnInitEffects(): Action {
      return PartnerStoreActions.initPartnerStore();
    }
  */
  constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
  ) { }

  loadPartnerStore$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PartnerStoreActions.loadPartnerStore),
      concatMap(action => {
        return this.http.get<any>(this.#configService.partnerLegacyApi + '/api/v1/partner/additional-information').pipe(
          map(result => {
            return PartnerStoreActions.loadPartnerStoreSuccess({
              data: result && result.body && result.body.partner_additional_information ? result.body.partner_additional_information : {}
            });
          }),
          catchError(error => of(PartnerStoreActions.loadPartnerStoreFailure({ error }), globalFailure({ error })))
        );
      })
    )
  );

  savePartnerStore$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PartnerStoreActions.savePartnerStore),
      concatMap(_action => {
        return this.http.patch<any>(this.#configService.partnerLegacyApi + '/api/v1/partner/additional-information', _action.data).pipe(
          map(result => {
            return PartnerStoreActions.savePartnerStoreSuccess({
              data: _action.data
            });
          }),
          catchError(error => {
            return of(PartnerStoreActions.savePartnerStoreFailure({ error }), globalFailure({ error }));
          })
        );
      })
    )
  );

}
